import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
  editLoading: false,
  editStatus: null,
  editErrors: null,
}

export const getters = {
  getDetails(state) {
    return state.data
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_DETAILS_MEMBER_REQUESTED(state) {
    state.loading = true
  },
  SET_DETAILS_MEMBER_RECEIVED(state, newValue) {
    state.loading = false
    state.data = newValue
    state.errors = null
  },
  SET_DETAILS_MEMBER_FAILED(state, errors) {
    state.loading = false
    state.data = null
    state.errors = errors
  },
  RESET_DETAILS_MEMBER(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async getDetailsById({ commit }, params) {
    commit('SET_DETAILS_MEMBER_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/get/',
        payload: params,
      })
      commit('SET_DETAILS_MEMBER_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_DETAILS_MEMBER_FAILED', error)
    }
  },
  resetMemberDetails({ commit }) {
    commit('RESET_DETAILS_MEMBER')
  },
}
